import type { ComponentTemplate } from "schemas/generated/componentTemplates";

import { findAncestorComponent } from "replo-runtime/shared/utils/component";
import { isElementPartial } from "replo-runtime/shared/utils/element";
import { getProduct } from "replo-runtime/store/ReploProduct";
import { fakeSwatches } from "replo-runtime/store/utils/fakeSwatches";

export const swatchOptionListCircular: ComponentTemplate = {
  id: "55134865-3102-4985-b08f-176922f8de9c",
  storeId: null,

  scope: "left-bar",
  type: "component",
  name: "Product/Circular Option List",
  leftBarCategory: { main: "product", subCategory: "productData" },
  preview: "product/circular-option-list.svg",
  tags: ["product", "product circular option list", "swatch"],
  transforms: [
    (component: any, parent: any, element: any, extras: any) => {
      if (
        !parent ||
        isElementPartial(element) ||
        !extras.productResolutionDependencies
      ) {
        return component;
      }

      const productComponent = findAncestorComponent(
        element,
        parent.id,
        (component) => component.type === "product",
      );

      const product = getProduct(
        productComponent?.props._product ?? null,
        extras.context ?? null,
        {
          productMetafieldValues: {},
          variantMetafieldValues: {},
          products: extras.productResolutionDependencies.products,
          currencyCode: extras.productResolutionDependencies.currencyCode,
          moneyFormat: extras.productResolutionDependencies.moneyFormat,
          moneyWithCurrencyFormat:
            extras.productResolutionDependencies.moneyWithCurrencyFormat,
          language: extras.productResolutionDependencies.language,
          fallbackStrategy: { type: "defaultProduct" },
          templateProduct: extras.productResolutionDependencies.templateProduct,
          isEditor: extras.productResolutionDependencies.isEditor,
          isShopifyProductsLoading: false,
        },
      );

      const fakeSwatch = fakeSwatches.find((swatch) => {
        return (
          swatch.name === "Fake Swatch 1" &&
          swatch.data.productIds?.includes(product!.productId)
        );
      });

      if (!fakeSwatch || !productComponent) {
        delete component.props._option;
        return component;
      }

      return component;
    },
  ],
  template: {
    id: "de83fa6f-337f-421a-93e8-8b7ffd0f7d36",
    name: "Circular Option List",
    type: "optionSelect",
    props: {
      style: {
        display: "flex",
        __flexGap: "12px",
        alignSelf: "stretch",
      },
      _option: {
        label: "Color",
        values: undefined,
      },
    },
    children: [
      {
        id: "fdc5bb2d-de30-4316-bd59-a028d4a7ad62",
        name: "Outer Circle",
        type: "container",
        props: {
          style: {
            color: "#FFFFFFFF",
            width: "50px",
            height: "50px",
            display: "flex",
            alignItems: "center",
            paddingTop: "0.5%",
            paddingLeft: "0.5%",
            paddingRight: "0.5%",
            paddingBottom: "0.5%",
            borderTopColor: "#00000000",
            borderTopWidth: "1px",
            justifyContent: "center",
            borderLeftColor: "#00000000",
            borderLeftWidth: "1px",
            borderRightColor: "#00000000",
            borderRightWidth: "1px",
            borderBottomColor: "#00000000",
            borderBottomWidth: "1px",
            borderTopLeftRadius: "50%",
            borderTopRightRadius: "50%",
            borderBottomLeftRadius: "50%",
            borderBottomRightRadius: "50%",
            borderTopStyle: "solid",
            borderRightStyle: "solid",
            borderBottomStyle: "solid",
            borderLeftStyle: "solid",
          },
        },
        children: [
          {
            id: "e4860142-e6ae-44af-937f-385a27d78f31",
            name: "Inner Circle",
            type: "container",
            props: {
              style: {
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderTopLeftRadius: "50%",
                borderTopRightRadius: "50%",
                borderBottomLeftRadius: "50%",
                borderBottomRightRadius: "50%",
                backgroundColor:
                  "{{attributes._currentOption._swatches.Fake Swatch 1.color}}",
              },
            },
            children: [],
          },
        ],
        variants: [
          {
            id: "6e5d4862-710b-47cf-a4a5-f20d72567b3c",
            name: "default",
            query: null,
            componentOverrides: null,
          },
          {
            id: "113da5a9-1668-4ca6-9e4d-9773cecdc359",
            name: "Hover",
            query: {
              type: "expression",
              operator: "or",
              statements: [
                {
                  id: "18ad1de3-50b3-4a81-901a-bcb487cd4698",
                  field: "interaction.hover",
                },
              ],
            },
            componentOverrides: null,
          },
          {
            id: "12d3be3b-c413-4f29-b059-9b8c4eeddc84",
            name: "Selected",
            query: {
              type: "expression",
              operator: "or",
              statements: [
                {
                  field: "state.product.selectedOptionValues",
                  id: "b3e03892-5561-4c6a-b18d-40b2c4b3a2a5",
                  operator: null,
                  value: null,
                },
              ],
            },
          },
        ],
        variantOverrides: {
          "113da5a9-1668-4ca6-9e4d-9773cecdc359": {
            componentOverrides: {
              "fdc5bb2d-de30-4316-bd59-a028d4a7ad62": {
                props: {
                  style: {
                    borderColor: null,
                    borderStyle: null,
                    borderWidth: null,
                    borderTopColor: "#000000FF",
                    borderTopStyle: "solid",
                    borderTopWidth: "1px",
                    borderLeftColor: "#000000FF",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1px",
                    borderRightColor: "#000000FF",
                    borderRightStyle: "solid",
                    borderRightWidth: "1px",
                    borderBottomColor: "#000000FF",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1px",
                  },
                },
              },
            },
          },
          "12d3be3b-c413-4f29-b059-9b8c4eeddc84": {
            componentOverrides: {
              "fdc5bb2d-de30-4316-bd59-a028d4a7ad62": {
                props: {
                  style: {
                    borderTopWidth: "1px",
                    borderRightWidth: "1px",
                    borderBottomWidth: "1px",
                    borderLeftWidth: "1px",
                    borderWidth: null,
                    borderTopColor: "#000000FF",
                    borderRightColor: "#000000FF",
                    borderBottomColor: "#000000FF",
                    borderLeftColor: "#000000FF",
                    borderColor: null,
                    borderTopStyle: "solid",
                    borderRightStyle: "solid",
                    borderBottomStyle: "solid",
                    borderLeftStyle: "solid",
                    borderStyle: null,
                  },
                },
              },
            },
          },
        },
      },
    ],
  },
};
